var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReportsHamMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1229 25.1296C23.8693 26.3728 21.8666 26.274 20.743 24.9944L16.4463 20.1411C18.0515 19.1383 19.3758 17.7333 20.1292 16.4531L24.9877 20.7497C26.3974 22.0189 26.2413 24.0008 25.1229 25.1296ZM13.2108 9.47743V17.2281C14.8027 16.6027 16.1852 15.2386 16.7481 14.1695V9.47743H13.2108ZM8.63324 4.7334V17.5766C9.83119 17.8707 11.0644 17.853 12.1705 17.5714V4.7334H8.63324ZM4.05566 12.1616V14.159C4.8277 15.4806 6.0656 16.6081 7.59288 17.2333V12.1616H4.05566Z",
    fill: "#8DC63F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.04202 17.7725C-1.01375 13.7162 -1.01426 7.11165 3.04202 3.05003C7.10973 -1.01663 13.6937 -1.01656 17.766 3.04952C21.7488 7.03868 21.8886 13.6523 17.766 17.7728C13.7707 21.7661 7.1764 21.9128 3.04202 17.7725ZM4.45296 4.46043C1.17395 7.744 1.17395 13.0832 4.45296 16.3624C7.76262 19.6773 13.0917 19.6259 16.3554 16.3622C19.7039 13.0137 19.5599 7.66983 16.3549 4.4602C13.0659 1.17497 7.74162 1.17224 4.45296 4.46043Z",
    fill: "#8DC63F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsHamMenu);
export default __webpack_public_path__ + "static/media/Reports_ham_menu.6be3cbcd4efa4d04114a89dd775c1fc1.svg";
export { ForwardRef as ReactComponent };